import { add_sad_send } from './helpers';
import { split_word_sequence, add_asr_sendx, xasr_process } from './services';
import { activeo } from './shared.svelte';
import { round_to_6_places } from './times';
import {
    add_audio_to_list,
    add_audio_to_listq
} from './modification1';
const sado = $state({
    previous: false,
    status: null,
    i: null,
    source_uid: null,
    pending_promise: null,
    // promise: null,
    // result: null,
    segments: [],
    // items: null,
    // vvsegs: [],
    // addedn: 0,
    source_uid_channels: [],
    docids: [],
    sad_previous: []
});
const asro = $state({
    previous: false,
    type: null,
    status: null,
    i: null,
    source_uid: null,
    pending_promise: null,
    promise: null,
    result: null,
    segments: [],
    items: null,
    vvsegs: [],
    addedn: 0,
    source_uid_channels: [],
    docids: [],
    asr_previous: []
});

// let active_channeln = $state(0);
// const un1 = active_channel.subscribe( x => active_channeln = x );

let ldco;

function run_sad(docids, ldc, source_uid_channels){
    // add_which = 'sad';
    // dialog_sad.showModal();
    // add_sad_p = add_sad_send(source_uid, ldc);
    // add_sad_p3 = add_sad_p.then( (data) => {
    //     console.log('adding')
    //     console.log(data);
    //     const f = add_timestamps(data, docids);
    //     f();
    //     add_cb( () => dialog_sad.close() );
    //     return 'displaying segments...';
    // } );
    ldco = ldc;
    if(sado.status){
        sado.previous = true;
        return;
    }
    sado.i = 0;
    sado.source_uid_channels = source_uid_channels;
    sado.docids = docids;
    run_sad_helper();
}

function run_sad_helper(){
    sado.status = 'pending';
    // sado.pending_promise = new Promise((x,y) => {});
    sado.pending_promise = add_sad_send(sado.source_uid_channels[sado.i], ldco).then(data => {
        console.log('adding')
        console.log(data)
        sado.status = 'adding';
        sado.segments = data;
        const f = add_timestamps(data, sado.docids);
        f();
        return data;
        // return new Promise((x,y) => {});
        return 'displaying segments...';
    });
}
    
function add_timestamps(o, docids) {
    return () => {
        let t;
        let len2;
        for(t = 0, len2 = o.ch1.length; t < len2; t++){
            let x = o.ch1[t];
            let span = {
                offset: x[0],
                length: round_to_6_places(x[1] - x[0])
            };
            // let docid = window.ldc.ns.waveform.docid.replace(/:B$/, ':A');
            add_audio_to_list(docids[0], '.SegmentList', 'new.Segment', span);
        }
        let u;
        let len3;
        for(u = 0, len3 = o.ch2.length; u < len3; u++) {
            let x = o.ch2[u];
            let span = {
                offset: x[0],
                length: round_to_6_places(x[1] - x[0])
            };
            console.log(span);
            // let docid = window.ldc.ns.waveform.docid.replace(/:A$/, ':B');
            add_audio_to_list(docids[1], '.SegmentList', 'new.Segment', span);
        }
        add_audio_to_listq();
    }
}

function run_asr4(type, docids, ldc, source_uid_channels){
    ldco = ldc;
    if(asro.status){
        asro.previous = true;
        return;
    }
    asro.type = type;
    asro.i = 0;
    asro.source_uid_channels = source_uid_channels;
    asro.docids = docids;
    // asro.status = 'init';
    // asro.pending_promise = new Promise((x,y) => {});
    // console.log('calling');
    // asro.pending_promise = cb();
    // asr_store.set(x);
    // asro.promise = cb().then(y => {
    run_asr4_helper();
}

function run_asr4_helper(){
    asro.status = 'pending';
    asro.pending_promise = xasr(asro.docids, ldco).then(y => {
        console.log('adding')
        console.log(y)
        asro.status = 'adding';
        // asro.result = y;
        // asr_store.set(x);
        // return new Promise((x,y) => { xasrr(x) });
        // return xasrr(y);
        // return asro;
        xasrr();
        // return `${asro.items.length} items loaded from asr (channel ${asro.i})`;
        return 'displaying segments...';
    });
}

// let asrp = $state();
// let asro = $state({});

const asrp = new Map();

function xasr(docids, ldc){
//   if(asrp) return asrp;
  const type = asro.type;
  const docid = docids[asro.i];
  const stereo = docid.match(/:A$/);
  if(asrp.has(docid)) return asrp.get(docid);
  asrp.set(docid, Promise.resolve());  // make sure it can't be called twice
  asro.source_uid = asro.source_uid_channels[asro.i];
  let p = add_asr_sendx(docid, type, ldc);
  if(type == 'rev') p = p.then(x => split_word_sequence(x, activeo.channel == asro.i, stereo));
  const mapf = (x) => x == 'ch_1' ? docids[1] : docid;
  p = p.then(x => xasr_process(x, mapf));
  // asrp = add_asr_sendx2(docid);
  asrp.set(docid, p);
  return p;
}

function xasrr(){
    asro.addedn = -1;
    // vvsegs_length = asro.vvsegs.length;
    // i = asro.i;
    const p = new Promise((x,y) => xasrrr(0, asro.vvsegs, x));
    asro.promise = p.then(() => {
        console.log('calling')
        asro.status = 'done';
        // x.asro = asro;
        // asr_store.set(x);
        const n = asro.source_uid_channels.length - asro.asr_previous.length;
        if(n > 1){
            asro.asr_previous.push(asro.source_uid_channels[asro.asr_previous.length]);
            // asr_previous.push(x);
            asro.i = asro.asr_previous.length;
            run_asr4_helper();
            // asr_store.set({
            //     type: 'asr4',
            //     status: 'init',
            //     i: asr_previous.length,
            //     previous_run: x
            // });
        }
    });
}

function xasrrr(i, vvsegs, f){
    asro.addedn = i;
    const max = vvsegs.length;
    // f('done');
    if(i == max){
        // setTimeout( () => asrp = null, 3000 );
        f('done');
        return;
    }
    let j = i;
    while(j < i + 100 && j < max){
        const s = vvsegs[j++];
        console.log(s);
        add_audio_to_list(s.docid, null, null, s);
    }
    add_audio_to_listq(() => xasrrr(j, vvsegs, f));
}

async function xasr4(type, docid, docids){
        return;
        // if(asrp) return;
        // let d = docid;//.replace('s3://ldc-car-connect', 's3://coghealth/connect');
        // let a = [];
        // // asro = {};
        // asro.segments = [];
        // asro.items = [];//.results.items;
        // asrp =     xasr44(                0, d, '_AB.wav', type, (x) => x == 'ch_1' ? docids[1] : docids[0])
        // .then(x => xasr44(asro.items.length, d, '_CD.wav', type, (x) => x == 'ch_1' ? docids[3] : docids[2]));

        // if(debug) console.log(asro);
        // if(asro.error) console.error(asro.error);
        // else           asro.show = true;
        // // sort_segments();
        // console.log(vvsegs);
        // return asrp;
    }

    async function xasr44(asro_i, x, y, type, mapf){
        let a = await add_asr_sendx(x.replace(/.wav:[ABCD]/, y), type);
        for(let i = 0; i < a.length; i++) asro.items.push(a[i]);
        let check = 0;
        while(asro_i < asro.items.length){
            check++;
            asro_i = xasr2(asro_i, mapf);
            // console.log(asro_i)
            if(check > 10000) break;
        }
    }


export {
    asro,
    sado,
    run_sad,
    run_asr4,
    xasrr
}
